import type { Theme } from '@mui/material/styles/createTheme'
import { styled } from '@mui/material'
import MuiSwitch from '@mui/material/Switch'
import { css } from '@emotion/react'
import type { SwitchProps } from './Switch.types'

type CssProps = SwitchProps & { theme?: Theme }

export const sizeStyles = ({ size }: Pick<CssProps, 'size'>) => {
  switch (size) {
    case 'small':
      return css`
        width: 28px;
        height: 16px;
        & .MuiSwitch-thumb {
          width: 12px;
          height: 12px;
          border-radius: 6;
        }
        & .MuiSwitch-track {
          border-radius: 8px;
        }
        & .MuiSwitch-switchBase {
          &.Mui-checked {
            transform: translateX(12px);
          }
        }
      `
    case 'large':
      return css`
        width: 60px;
        height: 28px;
        & .MuiSwitch-thumb {
          width: 24px;
          height: 24px;
          border-radius: 12;
        }
        & .MuiSwitch-track {
          border-radius: 14px;
        }
        & .MuiSwitch-switchBase {
          &.Mui-checked {
            transform: translateX(32px);
          }
        }
      `
    case 'medium':
    default:
      return css`
        width: 44px;
        height: 22px;
        & .MuiSwitch-thumb {
          width: 18px;
          height: 18px;
          border-radius: 9px;
        }
        & .MuiSwitch-track {
          border-radius: 11px;
        }
        & .MuiSwitch-switchBase {
          &.Mui-checked {
            transform: translateX(22px);
          }
        }
      `
  }
}

export const Switch = styled(MuiSwitch)<SwitchProps>`
  ${sizeStyles}
  padding: 0;
  display: flex;
  & .MuiSwitch-switchBase {
    padding: 2px;
    &.Mui-checked {
      color: #fff;
      & + .MuiSwitch-track {
        opacity: 1;
        background-color: ${({ theme }) => theme.palette.primary.main};
      }
    }
  }
  & .MuiSwitch-thumb {
    box-shadow: 0 2px 4px 0 rgb(0 35 11 / 20%);
    transition: ${({ theme }) => theme.transitions.create(['width'], { duration: 200 })};
  }
  & .MuiSwitch-track {
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.25);
    box-sizing: border-box;
  }
`
